import PropTypes from 'prop-types'
import { partial } from 'lodash'

import { namespace, schema } from './config'
import { ContractEditor } from './editor'
import { contractSchema } from './schema'
import { getNoTicketDocPath } from '../Common'
import { useFetchDoc } from '../DocHelper'
import { referenceDoc } from '../Reference'
import { EditorLoader } from '../SchemaBaseEditorLoader'
import { _queryContract } from './loader.gql'

const getPath = partial(getNoTicketDocPath, namespace, schema)

export const queryManifest = {
  gql: _queryContract,
  name: 'queryContract',
  getPath,
}

export const generateReferenceDoc = partial(
  referenceDoc,
  'contract_name',
  getPath,
  schema,
  namespace,
)

export function ContractEditorLoader({ docId }) {
  return (
    <EditorLoader
      DialogComp={ContractEditor}
      useFetchDocAndTicket={partial(
        useFetchDoc,
        _queryContract,
        'queryContract',
        docId,
      )}
      currentSchema={contractSchema}
    />
  )
}

ContractEditorLoader.propTypes = {
  docId: PropTypes.string.isRequired,
}

export default ContractEditorLoader
